import { IgSelect } from "@intelligems/ig-theme/IgSelect";
import type { ComponentPlacementLocation } from "@intelligems/ig-types/dtos/components";
import type { InsertType } from "@intelligems/ig-types/dtos/onsite-edits";
import { MenuItem } from "@mui/material";
import Stack from "@mui/material/Stack";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { INSERT_TYPE_LABELS, PLACEMENT_LOCATION_LABELS } from "./options";

export const LegacyPlacementSection = ({
  location,
  selector,
  insertType,
  selectorError,
  onLocationChange,
  onChange,
}: {
  location: ComponentPlacementLocation;
  selector: string;
  insertType: InsertType;
  selectorError?: boolean;
  onLocationChange: (location: ComponentPlacementLocation) => void;
  onChange: (changes: { selector?: string; insertType?: InsertType }) => void;
}) => (
  <Stack spacing={5}>
    <Panel.Header>Placement</Panel.Header>
    <IgSelect<ComponentPlacementLocation>
      fullWidth
      size="small"
      value={location}
      onChange={(event) => onLocationChange(event.target.value)}
    >
      {(
        Object.keys(PLACEMENT_LOCATION_LABELS) as ComponentPlacementLocation[]
      ).map((value) => (
        <MenuItem key={value} value={value}>
          {PLACEMENT_LOCATION_LABELS[value]}
        </MenuItem>
      ))}
    </IgSelect>

    <Stack spacing={1}>
      <Panel.Label>Anchor selector</Panel.Label>
      <Panel.TextField
        value={selector}
        onChange={(event) => onChange({ selector: event.target.value })}
        placeholder='form[action*="/cart/add"]:has([type="submit"])'
        error={selectorError}
      />
    </Stack>

    <IgSelect<InsertType>
      label="Position"
      fullWidth
      size="small"
      value={insertType}
      onChange={(event) => onChange({ insertType: event.target.value })}
    >
      {(Object.keys(INSERT_TYPE_LABELS) as InsertType[]).map((value) => (
        <MenuItem key={value} value={value}>
          {INSERT_TYPE_LABELS[value]}
        </MenuItem>
      ))}
    </IgSelect>
  </Stack>
);
